// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-orm-delete-dialog{overflow-y:unset!important}.m-orm-delete-dialog__avatar{position:absolute;top:-38px;left:50%;right:50%;transform:translate(-50%)}", ""]);
// Exports
module.exports = exports;
